import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk'; // Correct import of named export
import rootReducer from './reducers/rootReducer.ts';

// Apply thunk as middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;